import { createContext, FC, PropsWithChildren, useCallback, useEffect, useState } from "react";
import { TriggerContextType, TriggerObjectType } from "./types";
import { useMutation } from "react-query";
import { triggerHl7Messge } from "../../EMR/services";
export const HL7ContexTriggerContex = createContext<TriggerContextType>({
  setTrigger: () => {},
  trigger: { tab: "", encounterId: "" },
  triggerApi: () => {},
});

const HL7MessageTriggerProvider: FC<PropsWithChildren> = ({ children }) => {
  const [trigger, setTriggerState] = useState<TriggerObjectType>({
    encounterId: "",
    tab: "",
  });

const setTrigger = (params:TriggerObjectType)=>{
     setTriggerState(params)
}

const {mutate:triggerMessage} = useMutation(triggerHl7Messge,{
  onSuccess:(result)=>{
     if(result.responseIndicator == "success"){
      setTrigger({
        encounterId: "",
        tab: "",
      });
     }
  }
})

  const triggerApi = useCallback(() => {
    if (trigger.encounterId != "" && trigger.tab != "") {
      console.log("Api triggered",trigger);
      triggerMessage({
        encounterId:parseInt(trigger.encounterId),
        trigger:trigger.tab
      })
    } else {
      console.log("no changes for trigger");
    }
  },[trigger]);

  useEffect(()=>{
    return ()=>{
      setTrigger({
        tab:"",
        encounterId:""
      })
    }
  },[])

  return (
    <HL7ContexTriggerContex.Provider
      value={{ trigger, setTrigger, triggerApi }}
    >
      {children}
    </HL7ContexTriggerContex.Provider>
  );
};

export default HL7MessageTriggerProvider;
